import React from 'react'

import { XIcon } from '../icons/icons.js'
import { IconButton, IconButtonProps } from './IconButton.js'

export type CloseButtonProps = Omit<IconButtonProps, 'icon'>

export const CloseButton = ({
  accessibilityLabel,
  ...rest
}: CloseButtonProps) => {
  return (
    <IconButton
      variant="tertiaryNeutral"
      icon={<XIcon />}
      aria-label={accessibilityLabel ?? 'Close'}
      {...rest}
    />
  )
}
